import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';

const MultipleSelectionAlert = ({
  isOpen,
  onClose,
  message,
  onConfirm,
  leftButtonName,
  centerButtonName,
  rightButtonName,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle className='Multi-delete-popup'>{message}</DialogTitle>
      <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
        <DialogActions style={{ justifyContent: 'space-between' }}>
          {leftButtonName && (
            <Button
              onClick={onClose}
              variant='outlined'
              size='large'
              color='secondary'
              className='mb-2'
            >
              {leftButtonName}
            </Button>
          )}
          {centerButtonName && (
            <Button
              onClick={onClose}
              variant='contained'
              size='large'
              color='primary'
              className='mb-2'
            >
              {centerButtonName}
            </Button>
          )}
          {rightButtonName && (
            <Button
              onClick={() => handleConfirm()}
              variant='contained'
              size='large'
              color='primary'
              className='mb-2'
            >
              {rightButtonName}
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default MultipleSelectionAlert;
